function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9ee52e446d6897b0a7eb1e8b4fa17f98.jpg"
          alt="Ninja Warrior Training"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 w-full">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="mb-4 sm:mb-6">
            <span className="text-[#FF6B35] text-xs sm:text-sm font-bold uppercase tracking-wider">
              Welcome to Tri County Ninja
            </span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl sm:text-7xl md:text-8xl font-black text-white mb-4 sm:mb-6 leading-tight">
            Train Like a Ninja
          </h1>

          {/* Subheadline */}
          <p className="text-base sm:text-xl md:text-2xl text-white/90 mb-8 sm:mb-12 max-w-2xl leading-relaxed">
            Obstacle training, strength, agility, and confidence-building classes for kids, teens, and adults.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
            <button 
            onClick={() => scrollToSection('schedule')}
            className="bg-[#FF6B35] text-white px-8 py-3.5 sm:px-10 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl">
              View Class Schedule
            </button>
            <button 
            onClick={() => scrollToSection('contact')}
            className="bg-transparent border-2 border-white text-white px-8 py-3.5 sm:px-10 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-white hover:text-[#0A1628] transition-all duration-300 whitespace-nowrap cursor-pointer">
              Book a Visit
            </button>
            <button 
            onClick={() => scrollToSection('contact')}
            className="bg-[#0A1628] text-white px-8 py-3.5 sm:px-10 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-[#0A1628]/90 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Join Now
            </button>
          </div>

          {/* As Seen On ESPN Badge */}
          <div className="mt-10 inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-tv-2-line text-[#FF6B35] text-base"></i>
            </div>
            <span className="text-white/70 text-sm font-medium uppercase tracking-widest">As Seen On</span>
            <span className="text-white font-black text-lg tracking-tight leading-none">ESPN</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 right-12 z-10 hidden md:block">
        <div 
         onClick={() => scrollToSection('contact')}
        className="w-12 h-12 rounded-full border-2 border-[#FF6B35] flex items-center justify-center animate-bounce cursor-pointer">
          <i className="ri-arrow-down-line text-[#FF6B35] text-xl"></i>
        </div>
      </div>

      {/* Diagonal Cut */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-white transform origin-top-left -skew-y-2"></div>
    </section>
  );
}